import { ChangeEvent, forwardRef, HTMLProps, memo } from 'react';
import cx from 'classnames';
import TextareaAutosize, { TextareaAutosizeProps } from 'react-textarea-autosize';

import styles from './TextArea.module.scss';

export type TextAreaProps = Pick<
  HTMLProps<HTMLTextAreaElement>,
  'label' | 'placeholder' | 'className' | 'id' | 'value'
> &
  Pick<TextareaAutosizeProps, 'maxLength' | 'minRows'> & {
    invalid?: boolean;
    feedback?: string;
    onChange?(val: ChangeEvent<HTMLTextAreaElement>): void;
  };

const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(
  ({ invalid, feedback, className, ...htmlProps }, ref): JSX.Element => (
    <div className={cx(styles.container, { [styles.invalid]: invalid }, className)}>
      {htmlProps.label && (
        <label className={styles.label} htmlFor={htmlProps.id}>
          {htmlProps.label}
        </label>
      )}
      <div className={styles.content}>
        <TextareaAutosize ref={ref} minRows={3} {...htmlProps} />
      </div>
      {feedback && <span className={cx(styles.feedback, { [styles.error]: invalid })}>{feedback}</span>}
    </div>
  )
);

const memoizedTextArea = memo(TextArea);

export default memoizedTextArea;
